"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.USER_PASSWORD = exports.SERVER_PORT = exports.SERVER_URL = void 0;
exports.SERVER_URL = 'hello.quickcheck.ng';
exports.SERVER_PORT = '8089';
exports.USER_PASSWORD = '';
